export default __webpack_public_path__ + "static/media/CS-1200.9f961ba6.pdf";